import WelcomeModalLayout from './WelcomeModalLayout';

interface WelcomeModalProps {
  onStart: () => void;
  mascotSrc: string;
  mapSrc: string;
}

/** The guided journey's welcome: the tour map, centred copy, no partner branding. */
const AllAccessHero = ({ mapSrc }: { mapSrc: string }) => (
  <div className="preflight grid h-[320px] overflow-hidden">
    <img src={mapSrc} alt="" className="preflight pointer-events-none col-start-1 row-start-1 h-full w-full object-cover" />

    <div className="preflight col-start-1 row-start-1 flex flex-col items-center pt-[39px]">
      <h2 className="preflight preflight-h2 max-w-[1007px] text-center text-[35px] font-bold leading-[28px] text-white">
        Welcome to Your All-Access Guided Tour!
      </h2>
      <p className="preflight preflight-p mt-5 max-w-[804px] text-center text-lg font-medium leading-normal text-white">
        You set the pace! Go back, skip ahead, or take a break and chill with any animal you like.
      </p>
    </div>
  </div>
);

const WelcomeModal = ({ onStart, mascotSrc, mapSrc }: WelcomeModalProps) => (
  <WelcomeModalLayout
    hero={<AllAccessHero mapSrc={mapSrc} />}
    mascotSrc={mascotSrc}
    speech={
      'Follow me on our virtual visit to a few of the world’s top zoos today, as I share my favourite stories, ' +
      'special moments, and insider facts! Ready?'
    }
    buttonLabel="Let’s Step Into Nature"
    onStart={onStart}
  />
);

export default WelcomeModal;
